import React from "react";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import "./c95_home_slider.scss"
import axios from "axios";
import InnerHTML from 'dangerously-set-html-content';

class C95HomeSlider extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            cards: [],
            withLine: false
        };

        this.requireInternationalization = true;
        //this.dataUrl = this.dataUrl.replace('https://ho4out7of9.execute-api.eu-west-1.amazonaws.com/prod', 'https://www.luiss.it')

    };

    onDataLoaded(data) {
        if (data.cards) {
            this.state.cards = data.cards
        } else {
            axios.get(data.__data).then(
                (newData) => {
                    if (!newData || !newData.data || !newData.data.cards) return null;
                    this.state.cards = newData.data.cards
                    this.state.withLine = true
                    // return this.onOtherDataLoaded(index, otherData.data);
                });
        }

    }

    componentRender(data) {
        const sliderSettings = {
            arrows: false,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,

            lazyLoad: true,
            responsive: [{
                breakpoint: 350,
                settings: {
                    arrows: false,
                    dots: true,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '0px',
                    className: "center",
                    lazyLoad: false,
                }
            },
                {
                    breakpoint: 400,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 1.2,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '0px',
                        className: "center",
                        lazyLoad: false,
                    }
                },
                {
                    breakpoint: 970,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '-20px',
                        className: "center",
                        lazyLoad: false,
                    }
                }
            ]
            // beforeChange: (currIndex, nextIndex) => {
            //     // We cannot change the state, or the rerender won't let the slider component to work properly
            //     this.setState({active: nextIndex});
            // }
        };

        return (
            <div className="home-slider">
                <div className="home-slider-title">
                    {data.title}
                    <hr />
                </div>
                <div className="subtitle">
                    {data.subtitle}
                </div>
                <div className="slider">
                    {
                        this.state.cards.length > 0 &&
                        <Slider {...sliderSettings}>
                            {this.state.cards.map((card, index) => {
                                return (
                                    <div key={index} className='slider-item'>
                                        <div className="slider-item-content-container">
                                            <div className="slider-title" data-toggle="tooltip" title={card.title.length>48&&card.title}>
                                               {card.title.length>48?card.title.slice(0, 45)+"...": card.title}
                                               
                                            </div>
                                            {this.state.withLine ? <hr /> : ''}
                                            <div className="slider-content p-1">
                                                {card.summary?<InnerHTML html={card.summary} />:
                                                card.content?<InnerHTML html={card.content} />:""}
                                                
                                            </div>
                                            <div className="slider-button mt-auto">
                                                <button>
                                                    <a href={card.link_url}>{card.link_title}</a>
                                                </button>
                                            </div>
                                           
                                        </div>
                                    </div>
                                )
                            })}
                        </Slider>
                    }
                </div>
            </div>)
    }
}

export default C95HomeSlider;